import { apiClient } from './api';
import { User, UserUpdateInput, DashboardStats } from '../types';

export const authService = {
  // Get current user
  getCurrentUser: async (): Promise<User> => {
    const response = await apiClient.get('/auth/me');
    return response.user;
  },

  // Update user profile
  updateUser: async (userData: Partial<UserUpdateInput>): Promise<User> => {
    const response = await apiClient.put('/auth/me', userData);
    return response.user;
  },

  // Logout user
  logout: async (): Promise<{ message: string }> => {
    const response = await apiClient.post('/auth/logout');
    return { message: response.message || 'Logged out successfully' };
  },

  // Refresh token
  refreshToken: async (): Promise<string> => {
    const response = await apiClient.post('/auth/refresh');
    return response.token || '';
  },

  // Delete account
  deleteAccount: async (): Promise<{ message: string }> => {
    const response = await apiClient.delete('/auth/me');
    return { message: response.message || 'Account deleted successfully' };
  },

  // Get user statistics
  getUserStats: async (): Promise<DashboardStats> => {
    const response = await apiClient.get('/auth/stats');
    return response.stats;
  },
}; 